import React, {FC} from 'react';
import {Size, SizeMapping} from 'react-dfp';
import {adUnitToDivId} from 'utils/stringTools';
import Ad from '../Ad';

interface AdRepeatedProps {
  adUnitRoot: string;
  adUnitLetters: string[];
  index: number;
  step: number;
  scope: string;
  sizes: Size[];
  sizeMapping?: SizeMapping[];
}

const AdRepeated: FC<AdRepeatedProps> = ({
  adUnitRoot,
  adUnitLetters,
  index,
  step,
  scope,
  sizes,
  sizeMapping,
}: AdRepeatedProps) => {
  if (index < step || index % step) return null; // skip if index is less than 15 or not exact multiple of step

  const slotPosition = Math.floor(index / step); // e.g. 1, 2, 3, 4...
 
  // If the last adUnit letter is printed stop 
  if(slotPosition > adUnitLetters.length) return null;

  const slotIdentifierIndex = slotPosition - 1; // normalize for array index
  const slotIdentifier = adUnitLetters[slotIdentifierIndex];


  const adUnit = `${adUnitRoot}${slotIdentifier}`; // e.g. sport24.gr/Matchcenter_ros_300x250A
  const divId = adUnitToDivId(adUnit, scope);

  return <Ad adUnit={adUnit} divId={divId} scope={scope} sizes={sizes} sizeMapping={sizeMapping} />;
};

export default AdRepeated;
